import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import ModalContext from 'contexts/ModalContext'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'

const PromptCard = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${rem(12)};
  width: 100%;
  max-width: ${rem(420)};
  padding: ${rem(16)};
  border: ${rem(1)} solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${rem(16)};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
`

const PromptActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(8)};
`

function GuestChatLoginPrompt() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const handleLogin = useCallback(() => {
    showModal(<AccountAccessModal />)
  }, [showModal])

  return (
    <PromptCard>
      <Heading variant="heading4">
        {intl.formatMessage({
          id: '1NRbsuHc2mXTzV17BTWH',
          defaultMessage: 'Don’t lose this chat',
          description: 'Heading on the login prompt shown within a guest Trip Planner conversation',
        })}
      </Heading>
      <BodyText variant="medium">
        {intl.formatMessage({
          id: 'j1Duymo15f8jGvHbiaGO',
          defaultMessage: 'You’re planning as a guest. Log in to save your chat history.',
          description: 'Supporting text on the login prompt shown within a guest Trip Planner conversation',
        })}
      </BodyText>
      <PromptActions>
        <TextButton kind="primary" size="medium" onClick={handleLogin}>
          {intl.formatMessage({
            id: 'QKG27m0BGrZM1UJS_M8o',
            defaultMessage: 'Log in',
            description: 'Button text on the guest Trip Planner chat prompt that opens the login modal',
          })}
        </TextButton>
        <TextButton kind="secondary" size="medium" onClick={handleLogin}>
          {intl.formatMessage({
            id: '18DT7Dic-Nob2lRLuWYy',
            defaultMessage: 'Sign up for free',
            description: 'Button text on the guest Trip Planner chat prompt that opens the account access modal',
          })}
        </TextButton>
      </PromptActions>
    </PromptCard>
  )
}

export default GuestChatLoginPrompt
